(function () {
  var css =
    '.cgn-cbtn{position:absolute;top:50%;transform:translateY(-50%);z-index:6;width:3.2rem;height:3.2rem;border-radius:50%;background:rgba(255,255,255,.92);box-shadow:0 1px 6px rgba(0,0,0,.22);display:flex;align-items:center;justify-content:center;color:#1a1a1a;pointer-events:none}' +
    '.cgn-cbtn svg{width:1.3rem;height:1.3rem;display:block}' +
    '.cgn-cbtn--prev{left:.6rem}.cgn-cbtn--next{right:.6rem}' +
    '.cgn-dots{position:absolute;bottom:.7rem;left:0;right:0;display:flex;gap:.4rem;justify-content:center;z-index:6;pointer-events:none}' +
    '.cgn-dot{width:.5rem;height:.5rem;border-radius:50%;background:rgba(255,255,255,.55);box-shadow:0 0 2px rgba(0,0,0,.35)}' +
    '.cgn-dot--on{background:#fff}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function sizeUrl(u) {
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
  }

  function setup(card) {
    if (card.dataset.cgnCard) return;
    var link = card.querySelector('a[href*="/products/"]');
    var media = card.querySelector('.card__media');
    if (!link || !media) return;
    var href = link.getAttribute('href');
    var handle = (href.split('/products/')[1] || '').split('?')[0].split('#')[0];
    if (!handle) return;
    card.dataset.cgnCard = '1';
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var imgs = (p.images || []).map(sizeUrl);
        if (imgs.length < 2) return;
        var primary = media.querySelector('img');
        if (!primary) return;
        var inner = media.querySelector('.media');
        if (inner) inner.classList.remove('media--hover-effect');
        var all = media.querySelectorAll('img');
        for (var k = 1; k < all.length; k++) { all[k].style.display = 'none'; }
        primary.removeAttribute('srcset');
        primary.setAttribute('sizes', '(min-width:750px) 25vw, 50vw');
        if (getComputedStyle(media).position === 'static') media.style.position = 'relative';

        var idx = 0, dotEls = [];
        function show(i) {
          idx = (i + imgs.length) % imgs.length;
          primary.src = imgs[idx];
          for (var m = 0; m < dotEls.length; m++) {
            dotEls[m].className = 'cgn-dot' + (m === idx ? ' cgn-dot--on' : '');
          }
        }
        function mkBtn(cls, d) {
          var b = document.createElement('div');
          b.className = 'cgn-cbtn ' + cls;
          b.setAttribute('aria-hidden', 'true');
          b.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="' + d + '" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          return b;
        }
        var prev = mkBtn('cgn-cbtn--prev', 'M15 18l-6-6 6-6');
        var next = mkBtn('cgn-cbtn--next', 'M9 6l6 6-6 6');
        media.appendChild(prev);
        media.appendChild(next);
        var dots = document.createElement('div');
        dots.className = 'cgn-dots';
        for (var j = 0; j < imgs.length; j++) {
          var dt = document.createElement('span');
          dt.className = 'cgn-dot' + (j === 0 ? ' cgn-dot--on' : '');
          dots.appendChild(dt);
          dotEls.push(dt);
        }
        media.appendChild(dots);

        card.addEventListener('click', function (e) {
          var x = e.clientX, y = e.clientY;
          if (typeof x !== 'number') return;
          function inRect(el) {
            var r = el.getBoundingClientRect();
            var pad = 6;
            return x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad;
          }
          if (inRect(prev)) { e.preventDefault(); e.stopPropagation(); show(idx - 1); }
          else if (inRect(next)) { e.preventDefault(); e.stopPropagation(); show(idx + 1); }
        }, true);
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
